import React from 'react';
import styled from 'styled-components';
import Heading from './Heading';
import ImageRow from './ImageRow';

const StyledTheBreakdown = styled.div`
  display: flex;
  flex-direction: column;
  background: var(--neutral200);
  padding-top: 4.5rem;

  .join-us {
    align-self: center;
    text-align: center;
    width: 60%;
    padding-bottom: 2.5rem;
  }

  .check-back {
    align-self: center;
    text-align: center;
    width: 60%;
    padding: 4.5rem 0;
  }
`;

const TheBreakdown = ({ images }) => {
  return (
    <StyledTheBreakdown>
      <Heading
        withLine
        headingLevel={3}
        headingText="The breakdown with BCV"
        widthWrapper
        neutral200
      />
      <p className="join-us body-m-regular">
        Join us for our exclusive webinar series, The Breakdown with BCV, where we hone in on
        specific areas of social media with some of our experts.
      </p>
      <ImageRow images={images} />
      <p className="check-back heading-s-regular">
        Check back for more information on future webinars.
      </p>
    </StyledTheBreakdown>
  );
};

export default TheBreakdown;
